// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__M7n5A","productName":"Table_productName__MwaWG"};